/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Labels were "#9fc9ff" (≈1.9:1 on a white card) and white-on-nothing when active, because
// they were drawn for the gradient header. Now: secondary ink, accent when active/completed.
import typography from "assets/theme-dark/base/typography";
import colors from "assets/theme-dark/base/colors";
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { size, fontWeightRegular, fontWeightMedium } = typography;
const { ink, accent } = colors;

const stepLabel = {
  styleOverrides: {
    label: {
      marginTop: `${pxToRem(8)} !important`,
      fontWeight: fontWeightRegular,
      fontSize: size.xs,
      color: ink.secondary,
      textTransform: "none",

      "&.Mui-active": {
        fontWeight: `${fontWeightMedium} !important`,
        color: `${accent.onSurface} !important`,
      },

      "&.Mui-completed": {
        fontWeight: `${fontWeightRegular} !important`,
        color: `${ink.main} !important`,
      },
    },
  },
};

export default stepLabel;
